import { useContext } from 'react';
import { AuthContext } from '../../App';

/**
 * Conditionally renders children based on whether the user's client
 * has a specific module active.
 *
 * Usage:
 *   <ModuleGate module="tachograph">
 *     <StopsList />
 *   </ModuleGate>
 *
 *   <ModuleGate module="reports" fallback={<LockedBadge />}>
 *     <ReportsModal />
 *   </ModuleGate>
 */
function ModuleGate({ module, children, fallback = null }) {
  const { modules } = useContext(AuthContext);

  // If no modules array exists (e.g. local/mock mode), show everything
  if (!modules || modules.length === 0) return children;

  if (!modules.includes(module)) return fallback;

  return children;
}

export default ModuleGate;
